'use strict';

import vertex from './vertex.glsl';
import fragment from './fragment.glsl';

export const ShadowBoostShader = {
	name: 'ShadowBoostShader',
	defines: {},
	uniforms: {
		tDiffuse: {
			value: null
		},
		shadowThreshold: {
			value: 0.2
		},
		shadowBoost: {
			value: 5
		}
	},
	vertexShader: vertex,
	fragmentShader: fragment
};

